import React from 'react';
import {DataGrid} from "@mui/x-data-grid";
import {formatTimestampWithDOW} from "../../utils";

const common = {sortable: false, disableColumnMenu: true, headerClassName: 'grid-header'};
const activityLogGridColumns = [
    {...common, width: 200, headerName: 'Timestamp', field: 'ts', headerAlign: 'left', align: 'left', valueGetter: value => value ? formatTimestampWithDOW(value) : ''},
    {...common, width: 110, headerName: 'Manager', field: 'manager', headerAlign: 'left', align: 'left'},
    {...common, width: 500, headerName: 'Description', field: 'summary', headerAlign: 'left', align: 'left'}
];

const determineRowClass = (params) => {
    return `${params.row.id % 2 === 1 ? 'table-row-odd' : 'table-row-even'}`
};

export const ActivityLogGrid = ({rows}) => {
    return (
        <div style={{width: 812, marginTop: 20}}>
            <DataGrid columns={activityLogGridColumns} rows={rows} density="compact" hideFooter={true} autoHeight
                      getRowClassName={(params) => (determineRowClass(params))} disableRowSelectionOnClick
                      showToolbar disableColumnFilter disableColumnSelector disableDensitySelector/>
        </div>
    );
}
